var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#E9ECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.4375V23C21 23.5625 20.5312 24 20 24C19.4375 24 19 23.5625 19 23V15.4375L16.6875 17.7188C16.3125 18.125 15.6562 18.125 15.2812 17.7188C14.875 17.3438 14.875 16.6875 15.2812 16.3125L19.2812 12.3125C19.6562 11.9062 20.3125 11.9062 20.6875 12.3125L24.6875 16.3125C25.0938 16.6875 25.0938 17.3438 24.6875 17.7188C24.3125 18.125 23.6562 18.125 23.2812 17.7188L21 15.4375ZM14 23H18C18 24.125 18.875 25 20 25C21.0938 25 22 24.125 22 23H26C27.0938 23 28 23.9062 28 25V26C28 27.125 27.0938 28 26 28H14C12.875 28 12 27.125 12 26V25C12 23.9062 12.875 23 14 23ZM25.5 26.25C25.9062 26.25 26.25 25.9375 26.25 25.5C26.25 25.0938 25.9062 24.75 25.5 24.75C25.0625 24.75 24.75 25.0938 24.75 25.5C24.75 25.9375 25.0625 26.25 25.5 26.25Z",
    fill: "#3C4E62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon2);
export default __webpack_public_path__ + "static/media/upload-icon-2.2fcdddebf32917dd13295b1691cfe781.svg";
export { ForwardRef as ReactComponent };